<div *ngIf="fieldName">
  <div class="form-group" [ngClass]="customCss" [ngClass]="cls">
    <label [ngClass]="isRequired() ? 'required ' + clsLabel : clsLabel"
      [for]="id" *ngIf="!!displayLabel">
      {{displayLabel}}<span class="required-alert" *ngIf="!!isRequired()">*</span>
    </label>

    <textarea #input
      class="form-control"
      [ngClass]="touched ? 'ng-touched ' + clsInput  : clsInput"
      [id]="id"
      [ngModel]="value"
      [readOnly]="readOnly"
      (ngModelChange)="valueChange($event)"
      (blur)="onBlur($event)"
      [placeholder]="placeholder ? placeholder : displayLabel || ''"
      [rows]="rows"
      [disabled]="disabled">
    </textarea>

    <app-field-error-display
      *ngIf="errorMsg"
      [displayError]="isFieldInvalid()"
      [errorMsg]="errorMsg">
    </app-field-error-display>
  </div>
</div>
